export default "__VITE_ASSET__BFSDdRel__"